import { useState } from "react";
import "./style.css";

export default function AddHobbies({ hobbies = [], updateDetails, setShowHobbies }) {
  const [hobbyList, setHobbyList] = useState(hobbies || []);
  const [newHobby, setNewHobby] = useState("");

  const addHobby = () => {
    if (newHobby.trim() && !hobbyList.includes(newHobby.trim())) {
      setHobbyList([...hobbyList, newHobby.trim()]);
      setNewHobby("");
    }
  };

  const removeHobby = (index) => {
    const updatedHobbies = hobbyList.filter((_, i) => i !== index);
    setHobbyList(updatedHobbies);
  };

  const saveHobbies = async () => {
    await updateDetails({ hobbies: hobbyList });
    setShowHobbies(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addHobby();
    }
  };

  return (
    <div className="add_hobbies_container">
      <div className="add_hobbies_header">
        <span>Add Hobbies</span>
        <div className="add_hobbies_actions">
          <button className="blue_btn" onClick={saveHobbies}>
            Save
          </button>
          <button className="gray_btn" onClick={() => setShowHobbies(false)}>
            Cancel
          </button>
        </div>
      </div>
      
      <div className="hobbies_input_section">
        <input
          type="text"
          placeholder="Add a hobby (e.g., Reading, Gaming, Cooking)"
          value={newHobby}
          onChange={(e) => setNewHobby(e.target.value)}
          onKeyPress={handleKeyPress}
          className="hobby_input"
          maxLength={50}
        />
        <button onClick={addHobby} className="add_hobby_btn" disabled={!newHobby.trim()}>
          Add
        </button>
      </div>

      <div className="hobbies_list">
        {hobbyList.map((hobby, index) => (
          <div key={index} className="hobby_tag">
            <span>{hobby}</span>
            <button 
              onClick={() => removeHobby(index)}
              className="remove_hobby_btn"
              title="Remove hobby"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {hobbyList.length === 0 && (
        <div className="no_hobbies_message">
          No hobbies added yet. Share what you love to do!
        </div>
      )}
    </div>
  );
} 